const AppConfig = {
  Rules : {
    PasswordLength: 6,
    MFALength: 6,
    MaxKycImageSize: 4194304,
  },
  ROLE_MANAGER: ['manage'],
  DEFAULT_ROLES: ['export'],
  ORDER_STATUS: {
    Nhap: 0,
    NhapText: 'Đang nhập',
    HoanThanhNhap: 1,
    HoanThanhNhapText: 'Chờ xử lý',
    DangXuLy: 2,
    DangXuLyText: 'Đang xử lý',
    HoanThanh: 10,
    HoanThanhText: 'Hoàn thành',
    Huy: 99,
    HuyText: 'Huỷ',
  },
  KHACHHANG_MOI : 0,
  KHACHHANG_DANGHOATDONG: 1,
  KHACHHANG_DAHUY: 10,
  TIMEOUT_LOAD_HEADER_INFO: 60000, // 60s
  CANH_BAO_SO_LUONG: 500, //Cảnh báo số lượng tồn kho
  SETTINGKEYS: {
    IsKhoaDatDon:'KhoaDatDon',
    HeSoCk:'HeSoCk',
    LogoDonVi:'LogoDonVi',
    ShowDiemTichLuy:'ShowDiemTichLuy',
    GiaDanhMuc:'GiaDanhMuc',
    OrderExcelMarginLeft:'OrderExcelMarginLeft',
    OrderExcelMarginRight:'OrderExcelMarginRight',
    OrderExcelMarginTop:'OrderExcelMarginTop',
    ShowCkPercent:'ShowCkPercent',
  }
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/config/app.js